const TrashIcon = ({ ...props }) => {
  return (
    <svg
      width="45"
      height="44"
      viewBox="0 0 45 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="0.5"
        width="44"
        height="44"
        rx="22"
        fill="url(#paint0_linear_5631_18105)"
      />
      <g clipPath="url(#clip0_5631_18105)">
        <path
          d="M32.5 12.7087L29.0204 31.1676C29.0204 31.1676 28.534 32.4475 27.1955 31.8331L19.1297 25.3376C20.2138 24.3122 28.6242 16.3564 28.992 15.9956C29.5605 15.4372 29.2077 15.1049 28.5468 15.5272L16.124 23.828L11.3313 22.1303C11.3313 22.1303 10.5767 21.8486 10.5041 21.2342C10.4311 20.6198 11.3558 20.287 11.3558 20.287L30.8942 12.2222C30.8942 12.2222 32.5 11.4799 32.5 12.7087Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_5631_18105"
          x1="22.5"
          y1="0"
          x2="22.5"
          y2="44"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#39AEE3" />
          <stop offset="1" stopColor="#2295C4" />
        </linearGradient>
        <clipPath id="clip0_5631_18105">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(10.5 10)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TrashIcon;
